import React from "react";
import * as Sentry from "@sentry/react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Vella ErrorBoundary caught:", error, errorInfo);
    if (process.env.REACT_APP_SENTRY_DSN) Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", minHeight: "100vh",
          background: "linear-gradient(180deg,#F2F7FF 0%,#E8F0FB 55%,#EEF4FF 100%)",
          fontFamily: "-apple-system,BlinkMacSystemFont,'SF Pro Display','Inter',system-ui,sans-serif",
          color: "#0A1B3A", padding: "2rem", textAlign: "center"
        }}>
          <div style={{
            background: "rgba(255,255,255,0.72)", backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)", border: "1px solid rgba(255,255,255,0.6)",
            borderRadius: 20, padding: "44px 48px", maxWidth: 440,
            boxShadow: "0 8px 40px rgba(14,165,233,0.10), 0 2px 8px rgba(0,0,0,0.06)"
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: 16, marginBottom: 20,
              background: "rgba(239,68,68,0.10)", border: "1px solid rgba(239,68,68,0.2)",
              display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px"
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10, color: "#0A1B3A", letterSpacing: "-0.022em" }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: 14, color: "#5B7A99", lineHeight: 1.6, marginBottom: 24 }}>
              Vella encountered an unexpected error. Try again — if the problem persists, contact support.
            </p>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                display: "block", width: "100%", padding: "12px 24px", fontSize: 14,
                fontWeight: 600, background: "#0EA5E9", color: "#fff", border: "none",
                borderRadius: 10, cursor: "pointer", marginBottom: 10,
                boxShadow: "0 2px 8px rgba(14,165,233,0.35)"
              }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                display: "block", width: "100%", padding: "11px 24px", fontSize: 14,
                fontWeight: 500, background: "rgba(255,255,255,0.55)", color: "#5B7A99",
                border: "1px solid rgba(14,165,233,0.18)", borderRadius: 10, cursor: "pointer"
              }}
            >
              Refresh Page
            </button>
            <p style={{ fontSize: 12, color: "#9DB4CC", marginTop: 20 }}>
              Need help? <a href="mailto:team@amplifx.com" style={{ color: "#0EA5E9", textDecoration: "none" }}>team@amplifx.com</a>
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
